<template lang="html">
  <div class="ems">
    <section class="ems-feature-set">
    <h3>Event Management System (EMS&trade;)</h3>
      <ul class="ems-features">
        <li v-for="feature in features" class="ems-feature">
          <img :src="feature.icon" :alt="feature.alt">
          <span class="notch notch--light notch--lg notch--tm"></span>
          <p>{{ feature.desc }}</p>
        </li>
      </ul>
    </section>
  </div>
</template>

<script>
  export default {
    name: 'ems',
    data () {
      return {
        features: [
          {
            icon: '../static/svg/custom-online-calendars.svg',
            alt: 'Custom online calendars',
            desc: 'Custom online calendars'
          },
          {
            icon: '../static/svg/unlimited-users.svg',
            alt: 'Unlimited users with email login and password protection',
            desc: 'Unlimited users with email login and password protection'
          },
          {
            icon: '../static/svg/custom-permissions.svg',
            alt: 'Custom permissions for event submission and viewing options per region',
            desc: 'Custom permissions for event submission and viewing options per region'
          },
          {
            icon: '../static/svg/vp-directors-permissions.svg',
            alt: 'VP\'s and Directors have special permissions to view multiple schedules (regions)',
            desc: 'VP\'s and Directors have special permissions to view multiple schedules (regions)'
          },
          {
            icon: '../static/svg/reporting-capabilities.svg',
            alt: 'Reporting capabilities for all users to view future and past events',
            desc: 'Reporting capabilities for all users to view future and past events'
          },
          {
            icon: '../static/svg/seven-day-reminder.svg',
            alt: '7 day reminder notices auto generated and delivered via email to your sales staff',
            desc: '7 day reminder notices auto generated and delivered via email to your sales staff'
          },
          {
            icon: '../static/svg/event-requests-date-time-stamped.svg',
            alt: 'All event requests are date and time stamped',
            desc: 'All event requests are date and time stamped'
          }
        ]
      }
    }
  }
</script>

<style lang='scss'>
  // Import global settings file per component.
  @import 'src/assets/scss/settings.scss';

  .ems {
    padding: 7.500rem 1rem;
    background-image: $dark-blue-gradient;
  }

  .ems-feature-set {
    max-width: 75.000rem;
    margin: 0 auto;
    h3 {
      margin-bottom: 3.75rem;
      font-family: $barlowCondensed;
      color: $light-blue;
    }
  }

  .ems-features {
    list-style-type: none;
    margin: 0;
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(18.687rem, 1fr));
    grid-auto-rows: minmax(auto, 18.687rem);
    grid-gap: 0.063rem;
  }

  .ems-feature {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    align-items: center;
    width: 100%;
    background-color: $darkest-blue;
    img {
      margin-top: 1.5rem;
    }
    p {
      padding: 0 2rem;
      font-family: $barlowCondensed;
      font-size: 1.5rem;
      line-height: 1.2;
      color: $white;
      margin: 1.5rem 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Ems.vue